import styled from "styled-components";

export const Legend = styled.legend`
    font: normal normal normal 14px/20px Circular Std Book;
    color: #454546;
    margin-bottom: 20px;
`;

export const Label = styled.label`
    font: normal normal normal 12px/16px Circular Std Book;
    color: #454546;
    margin-bottom: 8px;
`;

export const ContainerSubText = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 6px;
`;

export const SubText = styled.span`
    font: normal normal 300 10px/13px Muli;
    text-align: right;
    color: #B8B4CC;
`;

export const ButtonContainer = styled.div`
    margin-top: 64px;
    margin-bottom: 20px;
    
    @media (max-width: 600px) {
        margin-bottom: 70px;
    }
`;

export const FormContainer = styled.div`
    width: 350px;

    @media (max-width: 500px){
        width: 100%;
    }
`;